import * as actionTypes from '../types/infoHistory';

const initialState = {
  loading: false,
  details: null
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_INFO_HISTORY:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_INFO_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        details: payload
      };
    case actionTypes.GET_INFO_HISTORY_FAIL:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default reducer;
